var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoading && _vm.isPlpExclusive
    ? _c(
        "div",
        [
          _c(
            "swiper",
            {
              ref: "swiper",
              staticClass: "rb-product-tile__images-carousel",
              attrs: { config: _vm.swiperConfig },
            },
            _vm._l(3, function (i) {
              return _c(
                "swiper-slide",
                {
                  key: i,
                  staticClass: "rb-product-tile-images-carousel__image",
                },
                [
                  _c("rb-dummy-skeleton", {
                    staticClass: "--image-skeleton",
                    attrs: { icon: "assets" },
                  }),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      )
    : !_vm.isLoading
    ? _c(
        "div",
        { staticClass: "rb-product-tile__carousel-wrapper" },
        [
          _c(
            "swiper",
            {
              ref: "swiper",
              staticClass: "rb-product-tile__images-carousel",
              class: {
                "--no-click": _vm.isPlpExclusive,
              },
              attrs: {
                config: _vm.swiperConfig,
                navigation: _vm.isPlpExclusive,
                "manual-swipe": _vm.isPlpExclusive,
                "click-prev-button": function () {
                  return _vm.goToSwipe("prev")
                },
                "click-next-button": function () {
                  return _vm.goToSwipe("next")
                },
              },
              on: { next: _vm.changeVariant, prev: _vm.changeVariant },
              scopedSlots: _vm._u([
                {
                  key: "navigationprev",
                  fn: function () {
                    return [
                      _c("rb-lazy-icon", {
                        staticClass: "--no-click",
                        attrs: {
                          icon: "caret-light-left",
                          text: "caret-light-left",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "navigationnext",
                  fn: function () {
                    return [
                      _c("rb-lazy-icon", {
                        staticClass: "--no-click",
                        attrs: {
                          icon: "caret-light-right",
                          text: "caret-big-rights",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(" "),
              _vm._v(" "),
              _vm._l(_vm.variants, function (color, index) {
                return [
                  color.images.primary && !_vm.isLoading
                    ? _c(
                        "swiper-slide",
                        {
                          key: index,
                          staticClass: "rb-product-tile-images-carousel__image",
                        },
                        [
                          index === 0
                            ? [
                                _vm.showTransition ||
                                (_vm.firstHover &&
                                  _vm.selectedVariantIndex === 0)
                                  ? _c("rb-lazy-media", {
                                      staticClass: "--transition-image",
                                      class: {
                                        loaded: _vm.transitionLoaded,
                                        "--transition-in-desk":
                                          !_vm.isMobile && _vm.showTransition,
                                      },
                                      attrs: {
                                        "force-load":
                                          _vm.isFirstTransitionInViewport,
                                        src: _vm.transitionImage,
                                      },
                                      on: { loaded: _vm.imageLoaded },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "custom-element-image",
                                            fn: function () {
                                              return [
                                                _c("rb-dummy-skeleton", {
                                                  staticClass:
                                                    "--image-loading",
                                                  attrs: { icon: "assets" },
                                                }),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    })
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c("rb-lazy-media", {
                            attrs: {
                              src: _vm.setImpolicy(color.images.primary),
                              "force-load":
                                _vm.isPlpExclusive || _vm.isInsideSearchPanel,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "custom-element-image",
                                  fn: function () {
                                    return [
                                      _c("rb-dummy-skeleton", {
                                        staticClass: "--image-loading",
                                        attrs: { icon: "assets" },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
        ],
        1
      )
    : _c("rb-lazy-media", { attrs: { src: _vm.variants[0].images.primary } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }